module.exports = __webpack_public_path__ + "static/img/rio.0dc40fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/rio.jpg
// module id = bTCR
// module chunks = 1